const PLOT_TYPE_ID_BY_PREFERENCE_KEY = {
  'permanent-preservation-area': 4,
  'legal-reserve': 5,
  'dam-lake': 6
}

export const buildQueryParams = mapPreferences => {
  const types = []

  Object.entries(mapPreferences).forEach(([key, value]) => {
    if (value)
      types.push(PLOT_TYPE_ID_BY_PREFERENCE_KEY[key])
  })

  return Object.entries({ types })
    .map(
      ([key, value]) => value.reduce(
        (acc, typeId, idx) =>
          `${ acc }${ key }[${ idx }]=${ typeId }${ idx <= value.length -2 ? '&' : '' }`, '?'
      )
    )
}

export const checkIfMapPreferencesAreTruthy = (mapPreferences) => (
  mapPreferences['permanent-preservation-area'] ||
  mapPreferences['legal-reserve'] ||
  mapPreferences['dam-lake']
)